require('./style.css')
var $ = require('jquery');

module.exports = {
	//for general use
	//outputs data in the form Isaias requested
	getEntityData: function(data){
		var d3 = require("d3"),
		cloud = require("./d3.layout.cloud.js");

		//Parse topics
		var topics = {};
		var counts = {};
		for (var key in data) {
			var ents = data[key]['entities'];
			if(ents){

				//Get Salience
				var sent = data[key]['sentiment']['score'];
				if(sent<=-0.3){
					sent = 0;
				}
				else if(sent>=0.3){
					sent = 2;
				}
				else{
					sent = 1;
				}

				//Update Count
				for (var i = 0; i < ents.length; i++) {
					var key = (ents[i]['name']+sent.toString());
					if (key in topics){
						topics[key][sent] += 1;
						counts[key] += 1;
					}
					else{
						topics[key] = [0,0,0]
						topics[key][sent] += 1;
						counts[key] = 1;
					}
				}
			}
		}

		var finalTopics = [];
		for (var key in topics) {
			var topic = {"entity" : key, "positive" : topics[key][2], "neutral" : topics[key][1], "negative" : topics[key][0]};
			finalTopics.push(topic);
		}

		return finalTopics;
	},


	//For use with drawWordCloud
	//Takes in complete JSON and returns the top n (numKeep) items
	getEntityDataForCloud: function(data, numKeep){
		var d3 = require("d3"),
		cloud = require("./d3.layout.cloud.js");

		//Parse topics
		var topics = {};
		var counts = {};
		for (var key in data) {
			var ents = data[key]['entities'];
			if(ents){

				//Get Salience
				var sent = data[key]['sentiment']['score'];
				if(sent<=-0.3){
					sent = 0;
				}
				else if(sent>=0.3){
					sent = 2;
				}
				else{
					sent = 1;
				}

				//Update Count
				for (i = 0; i < ents.length; i++) {
					var key = (ents[i]['name']+sent.toString());
					if (key in topics){
						topics[key] += ents[i]['salience'];
						counts[key] += 1;
					}
					else{
						topics[key] = ents[i]['salience'];
						counts[key] = 1;
					}
				}
			}
		}

		//Get average Salience
		var sizes = {};
		var colors = {};
		for (var key in topics) {
			var averageSalience = topics[key];
			var newKey = key.substring(0, key.length-1);
			sizes[newKey] = averageSalience;
			colors[newKey] = parseInt(key.substring(key.length-1, key.length));
		}

		var items = Object.keys(sizes).map(function(key) {
			return [key, sizes[key]];
		});

		// Sort the array based on salience/occurence
		items.sort(function(first, second) {
			return second[1] - first[1];
		});

		// take the top n items
		var n = numKeep;
		var cloudWords = items.slice(0, n);
		for (var i = 0; i < cloudWords.length; i++){
			cloudWords[i].push(colors[cloudWords[i][0]]);
		}

		return cloudWords;
	},

	//Takes in full JSON file
	//returns the total number of positive, neutral, and negative articles
	getTotalSentiment: function(data){
		var totalSentiment = {"negative" : 0, "neutral" : 0, "positive" : 0};
		for (var key in data) {
			var sent = data[key]['sentiment']['score'];
			if(sent<=-0.3){
				totalSentiment["negative"] += 1;
			}
			else if(sent>=0.3){
				totalSentiment["positive"] += 1;
			}
			else{
				totalSentiment["neutral"] += 1;
			}
		}
		return totalSentiment;
	},


	//Takes in full JSON file
	//returns the total count for all types
	getTypeCounts: function(data){
		var types = {};
		for (var key in data) {
			var type = data[key]['type'];
			if(type in types){
				types[type] += 1;
			}
			else {
				types[type] = 1;
			}
		}
		return types;
	},


	//Dont use this one, working on developing this one to take in data from getEntityData
	//Use drawWordCloud instead
	drawWordCloudFromEntityData: function(data){
		var d3 = require("d3"),
		cloud = require("./d3.layout.cloud.js");

		//Some more preprocessing before using word cloud library
		cloudWords = []
		for (var i = 0; i < data.length; i++){
			//making a data item for each topic, tone pair
			//will be of the form (text, magnitude, color)
			if (data[i]['positive']){
				cloudWords.push([data[i]['entity'], data[i]['positive'], 'lightgrey']);
			}
			if (data[i]['neutral']){
				cloudWords.push([data[i]['entity'], data[i]['neutral'], 'darkgrey']);
			}
			if (data[i]['negative']){
				cloudWords.push([data[i]['entity'], data[i]['negative'], 'black']);
			}
		}

		//Draw the word cloud
		//most of the stuff below here is straight from an example file
		var layout = cloud()
		.size([700, 700])
		.words(cloudWords.map(function(d) {
			return {text: d[0], size: 3+ d[1], color: d[2]};
		}))
		.padding(5)
		.rotate(function() { return ~~(Math.random() * 2) * 90; })
		.font("Impact")
		.fontSize(function(d) { return d.size; })
		.on("end", draw);

		layout.start();

		function draw(words) {
			var svg = d3.select("#wc-svg");
			svg.selectAll("*").remove();
			svg
			.attr("width", layout.size()[0])
			.attr("height", layout.size()[1])
			.append("g")
			.attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
			.selectAll("text")
			.data(words)
			.enter().append("text")
			.style("font-size", function(d) { return d.size + "px"; })
			.style("font-family", "Impact")
			.style("fill", function(d) {
				return d.color;
			})
			.attr("text-anchor", "middle")
			.attr("transform", function(d) {
				return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
			})
			.text(function(d) { return d.text; });
		}

	},




	drawWordCloud: function(cloudWords, onClick){
		var d3 = require("d3"),
		cloud = require("./d3.layout.cloud.js");

		//Draw the word cloud
		var layout = cloud();
		var checkExist = setInterval(function(){
			if ($('#wc-svg').length) {
				setTimeout(function(){

					console.log('Exists!');
					clearInterval(checkExist);
					console.log("wc-svg width height", $('#wc-svg').width(), $('#wc-svg').height())
					layout
					.size([$('#wc-svg').width(), $('#wc-svg').height()])
					.words(cloudWords.map(function(d) {
						return {text: d[0], size: 10+ d[1]*50.0, color: d[2], test: "haha", data: d};
					}))
					.padding(5)
					.rotate(function() { return ~~(Math.random() * 2) * 90; })
					.font("Impact")
					.fontSize(function(d) { return d.size; })
					.on("end", draw);
					layout.start();
				}, 100)
			}
		}, 200)


		function draw(words) {
					var svg = d3.select("#wc-svg");
					svg.selectAll("*").remove();
					svg
					.attr("width", layout.size()[0])
					.attr("height", layout.size()[1])
					.append("g")
					.attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
					.selectAll("text")
					.data(words)
					.enter().append("text")
					.style("font-size", function(d) { return d.size + "px"; })
					.style("font-family", "Impact")
					.style("fill", function(d) {
						if (d.color == 0){
							return "orange";
						}
						else if (d.color == 1){
							return "lightgrey";
						}
						else{
							return "green";
						}
					})
					.attr("text-anchor", "middle")
					.attr("transform", function(d) {
						return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
					})
					.text(function(d) { return d.text; })
					.on("click", function(d, i){
						console.log("text", d)
						console.log("data", d.data)
						var topic = {name: d.data[0], salience: d.data[1]};
						onClick(d.data[0])
					})
				}



	}
}



// WEBPACK FOOTER //
// ./src/WordCloud/wordCloud.js